export const ONBOARDING_STEP_KEY = 'onboarding:step'
export const ONBOARDING_DOC_INDEX_KEY = 'onboarding:doc_index'
export const ONBOARDING_GOOGLE_EMAIL_PENDING_KEY = 'onboarding:google_email_pending'
